<template>
  <div id="main-wrapper">
    <NavbarDark />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{ pageTitle }}</h2>
            <span class="ipn-subtitle"></span>
          </div>
        </div>
      </div>
    </div>

    <section class="gray-simple">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="submit-page">
              <div class="form-submit">
                <h3>Basic Information</h3>
                <div class="submit-section">
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label class="mb-1"
                        >Property Title<span
                          class="tip-topdata"
                          data-tip="Property Title"
                          ><i class="fa-solid fa-info"></i></span
                      ></label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="propertyTitle"
                        @input="errors.propertyTitle = ''"
                      />
                      <p v-if="errors.propertyTitle" class="error-message">
                        {{ errors.propertyTitle }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Status</label>
                      <Multiselect
                        v-model="status"
                        :options="statusOptions"
                        placeholder="Select Status"
                        class="form-control px-0"
                        @change="errors.status = ''"
                      />
                      <p v-if="errors.status" class="error-message">
                        {{ errors.status }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Property Type</label>
                      <Multiselect
                        v-model="propertyType"
                        :options="propertyTypeOptions"
                        placeholder="Show All"
                        class="form-control px-0"
                        @change="errors.propertyType = ''"
                      />
                      <p v-if="errors.propertyType" class="error-message">
                        {{ errors.propertyType }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Price</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="CAD"
                        v-model="price"
                        @input="errors.price = ''"
                      />
                      <p v-if="errors.price" class="error-message">
                        {{ errors.price }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Sqft</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="area"
                        @input="errors.area = ''"
                      />
                      <p v-if="errors.area" class="error-message">
                        {{ errors.area }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Bedrooms</label>
                      <Multiselect
                        v-model="bedrooms"
                        :options="roomOptions"
                        placeholder="Bedrooms"
                        class="form-control px-0"
                        @change="errors.bedrooms = ''"
                      />
                      <p v-if="errors.bedrooms" class="error-message">
                        {{ errors.bedrooms }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Bathrooms</label>
                      <Multiselect
                        v-model="bathrooms"
                        :options="bathOptions"
                        placeholder="Bathrooms"
                        class="form-control px-0"
                        @change="errors.bathrooms = ''"
                      />
                      <p v-if="errors.bathrooms" class="error-message">
                        {{ errors.bathrooms }}
                      </p>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Available Date</label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="availableDate"
                        @change="errors.availableDate = ''"
                      />
                      <p v-if="errors.availableDate" class="error-message">
                        {{ errors.availableDate }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-submit">
                <h3>Gallery</h3>
                <!-- <div class="submit-section">
                  <div class="row">
                    <div class="form-submit middle-logo m-5" id="imagesSection">
                     
                      <div class="form-row position-relative">
                        <div
                          class="position-absolute w-100 h-100 top-0 bottom-0"
                        >
                          
                          <input
                            @change="handleChange($event)"
                            type="file"
                            id="images"
                            name="images"
                            accept="image/*"
                            multiple
                          />
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="submit-section">
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label class="mb-1">Upload Photos * (Max 8)</label>
                      <input
                        type="file"
                        class="form-control"
                        multiple
                        @change="handleFileUpload"
                        accept="image/*"
                      />
                      <p v-if="errors.files" class="error-message">
                        {{ errors.files }}
                      </p>
                    </div>

                    <!-- 4. Add Image Preview Section -->
                    <div
                      v-if="combinedImagePreviews.length > 0"
                      class="col-md-12 mb-3"
                    >
                      <p class="text-muted small">
                        You can drag and drop images to change their order.
                      </p>
                      <!-- 4. Use the draggable component -->
                      <div class="image-preview-container">
                        <div
                          v-for="preview in combinedImagePreviews"
                          :key="preview.id"
                          class="image-preview-item"
                        >
                          <img :src="preview.src" alt="Image Preview" />
                          <button
                            @click="removeImage(preview.id)"
                            class="remove-image-btn"
                            type="button"
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-submit mt-4">
                <h3>Location</h3>
                <div class="submit-section">
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label class="mb-1">Address *</label>
                      <input
                        id="address-input"
                        type="text"
                        class="form-control"
                        placeholder="Start typing your property address..."
                        ref="addressInput"
                        v-model="address"
                        @input="errors.address = ''"
                        :class="{ 'is-invalid': errors.address }"
                      />
                      <div v-if="errors.address" class="error-message">
                        {{ errors.address }}
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">City</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="City"
                        v-model="city"
                        :class="{ 'is-invalid': errors.city }"
                      />
                      <div v-if="errors.city" class="error-message">
                        {{ errors.city }}
                      </div>
                    </div>

                    <div class="form-group col-md-6">
                      <label class="mb-1">Postal Code *</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Postal Code"
                        v-model="zipCode"
                        :class="{ 'is-invalid': errors.zipCode }"
                      />
                      <div v-if="errors.zipCode" class="error-message">
                        {{ errors.zipCode }}
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="mb-1">Street Number</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Street Number"
                        v-model="streetNumber"
                        @input="errors.streetNumber = ''"
                      />
                      <p v-if="errors.streetNumber" class="error-message">
                        {{ errors.streetNumber }}
                      </p>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="mb-1">Street Name</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Street Name"
                        v-model="route"
                        @input="errors.route = ''"
                      />
                      <p v-if="errors.route" class="error-message">
                        {{ errors.route }}
                      </p>
                    </div>
                    <div class="form-group col-md-6">
                      <label class="mb-1">Province *</label>
                      <Multiselect
                        v-model="state"
                        :options="provinceOptions"
                        placeholder="Select Province"
                        class="form-control px-0"
                        @change="errors.state = ''"
                      />
                      <p v-if="errors.state" class="error-message">
                        {{ errors.state }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-submit">
                <h3>Detailed Information</h3>
                <div class="submit-section">
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label class="mb-1">Description</label>
                      <textarea
                        class="form-control h-120"
                        v-model="description"
                      ></textarea>
                    </div>

                    <div class="form-group col-md-12">
                      <label class="mb-1">Video URL (optional)</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="e.g. https://www.youtube.com/watch?v=your_video_id"
                        v-model="videoUrl"
                      />
                    </div>

                    <div class="form-group col-md-12">
                      <label class="mb-1">Other Features (optional)</label>
                      <div class="o-features">
                        <ul class="no-ul-list third-row">
                          <li>
                            <input
                              id="f-1"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Air Condition"
                            />
                            <label for="f-1" class="form-check-label ms-1"
                              >Air Condition</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-2"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Electricity Bill Included"
                            />
                            <label for="f-2" class="form-check-label ms-1"
                              >Electricity Bill Included</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-3"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Internet"
                            />
                            <label for="f-3" class="form-check-label ms-1"
                              >Internet</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-4"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Microwave"
                            />
                            <label for="f-4" class="form-check-label ms-1"
                              >Microwave</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-5"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Smoking allowed"
                            />
                            <label for="f-5" class="form-check-label ms-1"
                              >Smoking Allowed</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-6"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Pets Allowed"
                            />
                            <label for="f-6" class="form-check-label ms-1"
                              >Pets Allowed</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-7"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Elevator"
                            />
                            <label for="f-7" class="form-check-label ms-1"
                              >Elevator</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-8"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Parking"
                            />
                            <label for="f-8" class="form-check-label ms-1"
                              >Parking</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-9"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Garage"
                            />
                            <label for="f-9" class="form-check-label ms-1"
                              >Garage</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-10"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Lawn maintenance"
                            />
                            <label for="f-10" class="form-check-label ms-1"
                              >Lawn Maintenance</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-11"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Tenant Insurance needed"
                            />
                            <label for="f-11" class="form-check-label ms-1"
                              >Tenant Insurance Needed</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-12"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Water Bill Included"
                            />
                            <label for="f-12" class="form-check-label ms-1"
                              >Water Bill Included</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-13"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Washer and Dryer"
                            />
                            <label for="f-13" class="form-check-label ms-1"
                              >Washer and Dryer</label
                            >
                          </li>
                          <li>
                            <input
                              id="f-14"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Furnished"
                            />
                            <label for="f-14" class="form-check-label ms-1"
                              >Furnished</label
                            >
                          </li>

                          <li>
                            <input
                              id="f-15"
                              class="form-check-input"
                              type="checkbox"
                              v-model="features"
                              value="Security Check"
                            />
                            <label for="f-15" class="form-check-label ms-1"
                              >Security Check</label
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-submit">
                <h3>Contact Information</h3>
                <div class="submit-section">
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label class="mb-1">Name *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="name"
                        @input="errors.name = ''"
                      />
                      <p v-if="errors.name" class="error-message">
                        {{ errors.name }}
                      </p>
                    </div>

                    <div class="form-group col-md-4">
                      <label class="mb-1">Email *</label>
                      <input
                        type="email"
                        class="form-control"
                        v-model="email"
                        @input="errors.email = ''"
                      />
                      <p v-if="errors.email" class="error-message">
                        {{ errors.email }}
                      </p>
                    </div>

                    <div class="form-group col-md-4">
                      <label class="mb-1">Phone *</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="phone"
                        @input="formatPhoneNumber"
                        maxlength="15"
                      />
                      <p v-if="errors.phone" class="error-message">
                        {{ errors.phone }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group col-lg-12 col-md-12">
                <label class="mb-1">GDPR Agreement *</label>
                <ul class="no-ul-list">
                  <li>
                    <input
                      id="aj-1"
                      class="form-check-input"
                      name="aj-1"
                      type="checkbox"
                      v-model="gdprAgreement"
                      @change="errors.gdprAgreement = ''"
                    />
                    <label for="aj-1" class="form-check-label ms-1"
                      >I consent to having this website store my submitted
                      information so they can respond to my inquiry.</label
                    >
                  </li>
                </ul>
                <p v-if="errors.gdprAgreement" class="error-message">
                  {{ errors.gdprAgreement }}
                </p>
              </div>

              <div class="form-group col-lg-12 col-md-12">
                <button
                  class="btn btn-primary fw-medium px-5"
                  type="button"
                  @click="sendMessage"
                  :disabled="isSubmitting"
                >
                  <span
                    v-if="isSubmitting"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {{ isSubmitting ? "Submitting..." : "Submit & Preview" }}
                </button>
              </div>

              <!-- 2. Use the LoadingSpinner component, controlled by isSubmitting -->
              <LoadingSpinner v-if="isSubmitting" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref, onUnmounted, onMounted, computed } from "vue";
import NavbarDark from "@/components/navbar/navbar-dark.vue";
import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import LoadingSpinner from "@/components/loading-spinner.vue"; // 1. Import the spinner component
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
//import { VueDraggableNext } from "vue-draggable-next"; // 1. Import draggable for reordering
import FooterDark from "@/components/footer/footer-dark.vue"; // 1. Import FooterDark
import ScrollToTop from "@/components/scroll-to-top.vue"; // 2. Import ScrollToTop
const router = useRouter();
const store = useStore();
const broute = useRoute();
// Form fields
const propertyTitle = ref("");
const status = ref("");
const propertyType = ref("");
const price = ref("");
const area = ref("");
const bedrooms = ref("");
const bathrooms = ref("");
const availableDate = ref("");
const address = ref("");
//const address1 = ref(""); // To hold the full formatted address from Google Places
const city = ref("");
const state = ref("");
const zipCode = ref("");
const description = ref("");
const videoUrl = ref("");
const ForRent = ref(false);
const placeId = ref(""); // To hold the Google Place ID
const latitude = ref(null); // To hold the latitude
const longitude = ref(null); // To hold the longitude

const features = ref([]);
const name = ref("");
const email = ref("");
const phone = ref("");
const gdprAgreement = ref(false);
//const files = ref(null);
//const imagePreviews = ref([]); // 1. Add a ref for image preview URLs
const combinedImagePreviews = ref([]); // This will be the single source of truth for previews
const deletedImages = ref([]); // To track URLs of existing images to be deleted
// const loading = ref(false);
const errors = ref({}); // To hold validation errors
const isSubmitting = ref(false);

//const addressInput = ref(null); // A ref to hold the address input element
const route = ref(""); // To hold the street name
const streetNumber = ref(""); // To hold the street number
//const fetchPropertyForEdit = ref(null); // To hold fetched property data for editing
const Verified = ref(false); // To hold verified status
const PropertyClosed = ref(false);
const PropertyArchived = ref(false);
// State for edit mode
const isEditMode = ref(false);
const propertyId = ref(null);
// Add a ref for existing images
//const existingImages = ref([]);
const renderDraggable = ref(true); // 1. Add this ref to control rendering
// Computed property for the page title
const pageTitle = computed(() =>
  isEditMode.value ? "Edit Property" : "Submit Property"
);

// 3. Create a function to populate the form fields
const populateForm = (propertyData) => {
  if (!propertyData) return;

  propertyTitle.value = propertyData.name || "";
  status.value = propertyData.tag2 || "";
  propertyType.value = propertyData.type || "";
  price.value = propertyData.propertyValue || "";
  area.value = parseFloat(propertyData.sqft)
    ? String(parseFloat(propertyData.sqft))
    : "";
  bedrooms.value = propertyData.beds
    ? String(parseFloat(propertyData.beds))
    : "";
  bathrooms.value = propertyData.washrooms
    ? String(parseFloat(propertyData.washrooms))
    : "";
  availableDate.value = propertyData.availableDate || "";
  address.value = propertyData.loction || "";
  city.value = propertyData.city || "";
  state.value = propertyData.Province || "";
  zipCode.value = propertyData.PostalCode || "";
  description.value = propertyData.description1 || "";
  videoUrl.value = propertyData.videoUrl || "";

  const featuresFromDb = propertyData.features;
  if (featuresFromDb && typeof featuresFromDb === "object") {
    features.value = Object.keys(featuresFromDb).filter(
      (key) => featuresFromDb[key] === "Yes"
    );
  } else {
    features.value = [];
  }

  name.value = propertyData.customerName || "";
  email.value = propertyData.customerEmail || "";
  phone.value = propertyData.customerPhone || "";
  gdprAgreement.value = true;
  placeId.value = propertyData.placeId || "";
  latitude.value = propertyData.latitude || null;
  longitude.value = propertyData.longitude || null;
  streetNumber.value = propertyData.streetNumber || "";
  route.value = propertyData.streetName || "";
  Verified.value = propertyData.verified || false;
  PropertyClosed.value = propertyData.propertyClosed || false;
  PropertyArchived.value = propertyData.popertyArchived || false;

  // --- THIS IS THE CRITICAL PART FOR IMAGES ---
  const existingImages = propertyData.image || [];
  const existingPreviews = existingImages.map((url, index) => ({
    id: `existing-${index}-${Date.now()}`,
    src: url,
    type: "existing",
    file: null,
  }));

  // 3. Force the draggable component to re-render
  renderDraggable.value = false;

  //await nextTick();
  // 5. Simplify the array update
  combinedImagePreviews.value = existingPreviews;
  console.log("Image previews combined:", combinedImagePreviews.value);
};

// 4. Use 'watch' to wait for the data to become available

onMounted(() => {
  loadGoogleMapsScript();

  if (broute.query.id) {
    isEditMode.value = true;
    propertyId.value = broute.query.id;

    const propertyData = store.getters["properties/currentProperty"];

    if (propertyData) {
      // 6. Use nextTick to ensure the DOM is updated before populating the form
      // This solves the image preview rendering issue with the draggable component.

      populateForm(propertyData);
    } else {
      // This is a fallback in case the getter is not immediately available.
      // You might need to dispatch an action here if the data isn't pre-loaded.
      console.warn("Property data not found in store on mount.");
    }
  }
});

// Map of province abbreviations to full names

const provinceMap = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  NT: "Northwest Territories",
  NU: "Nunavut",
  YT: "Yukon",
};

// 1. Function to load the Google Maps script
const loadGoogleMapsScript = () => {
  if (window.google && window.google.maps) {
    initAutocomplete();
    return;
  }

  // 1. Store the key in a variable. Vue CLI replaces this at build time.
  const apiKey = process.env.VUE_APP_mapKEY;

  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  script.onload = () => {
    initAutocomplete();
  };

  // 3. Add error handling to see if the script fails to load.
  script.onerror = () => {
    console.error(
      "Failed to load the Google Maps script. Check the API key and network connection."
    );
    Swal.fire({
      title: "Network Error",
      text: "Could not load the map service. Please check your internet connection and try again.",
      icon: "error",
    });
  };
};

// 2. Function to initialize the Autocomplete feature
const initAutocomplete = () => {
  // Ensure the google object is loaded before proceeding.
  if (
    typeof google === "undefined" ||
    typeof window.google.maps === "undefined"
  ) {
    console.error("Google Maps script not loaded yet. Retrying in 100ms.");
    setTimeout(initAutocomplete, 100); // Retry after a short delay
    return;
  }
  const addressInput = document.getElementById("address-input");
  if (!addressInput) return;

  const autocomplete = new window.google.maps.places.Autocomplete(
    addressInput,
    {
      types: ["address"],
      componentRestrictions: { country: "ca" },
    }
  );

  // This is the crucial part that was missing or incorrect
  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();

    if (!place.geometry) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      console.warn("No details available for input: '" + place.name + "'");
      return;
    }

    // 1. Manually update your Vue ref with the formatted address.
    // This synchronizes the component's state with what the user sees.
    address.value = place.formatted_address;

    // 2. Clear any previous validation error for the address field.
    if (errors.value.address) {
      delete errors.value.address;
    }

    // 3. Extract and set other address components (street, city, etc.)
    placeId.value = place.place_id;
    latitude.value = place.geometry?.location?.lat() || null;
    longitude.value = place.geometry?.location?.lng() || null;
    let streetNumberVal = "";
    let routeVal = "";

    for (const component of place.address_components) {
      const componentType = component.types[0];
      switch (componentType) {
        case "street_number":
          streetNumberVal = component.long_name;
          break;
        case "route":
          routeVal = component.long_name;
          break;
        case "locality":
          city.value = component.long_name;
          break;
        case "administrative_area_level_1": {
          const shortName = component.short_name; // e.g., "NB"
          // Look up "NB" in the map to get "New Brunswick".
          // If not found, fall back to the long_name from Google.
          state.value = provinceMap[shortName] || component.long_name;
          break;
        }
        case "postal_code":
          zipCode.value = component.long_name;
          break;
      }
    }
    streetNumber.value = streetNumberVal;
    route.value = routeVal;
  });
};

// 1. Add this function to filter input
const formatPhoneNumber = (event) => {
  // Replace any character that is not a digit with an empty string
  const formatted = event.target.value.replace(/[^0-9]/g, "");
  phone.value = formatted;
};
// Options for dropdowns
const statusOptions = ref(["For Rent", "For Sale"]);
const propertyTypeOptions = ref([
  "Detached",
  "Apartment",
  "Semi-Detached",
  "Office",
  "Basement",
  "Garage",
]);
const roomOptions = ref(["1", "2", "3", "4", "5", "6"]);
const bathOptions = ref([
  "1",
  "1.5",
  "2",
  "2.5",
  "3",
  "3.5",
  "4",
  "4.5",
  "5",
  "5.5",
  "6",
]);
const provinceOptions = ref([
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Nova Scotia",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Northwest Territories",
  "Nunavut",
  "Yukon",
]);

// Helper function to convert a file to a Base64 string
const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

// Handle file input change
// const handleChange = (event) => {
//   const input = event.target;
//   if (input.files && input.files.length > 0) {
//     files.value = input.files;
//   }
// };

// 3. Clean up URLs when the component is unmounted
onUnmounted(() => {
  // Iterate over the correct array
  combinedImagePreviews.value.forEach((preview) => {
    // Only revoke URLs for newly added images to prevent memory leaks
    if (preview.type === "new") {
      URL.revokeObjectURL(preview.src);
    }
  });
});
// Validation function
const validate = () => {
  errors.value = {}; // Reset errors

  // Required fields
  if (!propertyTitle.value)
    errors.value.propertyTitle = "Property title is required.";
  if (!status.value) errors.value.status = "Status is required.";
  if (!propertyType.value)
    errors.value.propertyType = "Property type is required.";
  if (!bedrooms.value)
    errors.value.bedrooms = "Number of bedrooms is required.";
  if (!bathrooms.value)
    errors.value.bathrooms = "Number of bathrooms is required.";
  if (!availableDate.value)
    errors.value.availableDate = "Available date is required.";
  if (!address.value) errors.value.address = "Address is required.";
  if (!city.value) errors.value.city = "City is required.";
  if (!state.value) errors.value.state = "Province is required.";
  if (!zipCode.value) errors.value.zipCode = "Postal code is required.";
  if (!name.value) errors.value.name = "Name is required.";
  if (!phone.value) errors.value.phone = "Phone number is required.";
  if (!gdprAgreement.value)
    errors.value.gdprAgreement = "You must agree to the terms.";
  // Add validation for street number and name
  if (!streetNumber.value)
    errors.value.streetNumber = "Street number is required.";
  if (!route.value) errors.value.route = "Street name is required.";

  // Number fields
  if (!price.value) {
    errors.value.price = "Price is required.";
  } else if (isNaN(Number(price.value))) {
    errors.value.price = "Price must be a valid number.";
  }
  if (!area.value) {
    errors.value.area = "Sqft is required.";
  } else if (isNaN(Number(area.value))) {
    errors.value.area = "Sqft must be a valid number.";
  }

  // Email field
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email.value) {
    errors.value.email = "Email is required.";
  } else if (!emailPattern.test(email.value)) {
    errors.value.email = "Please enter a valid email address.";
  }

  // 2. Update phone validation
  if (!phone.value) {
    errors.value.phone = "Phone number is required.";
  } else if (phone.value.length < 10) {
    errors.value.phone =
      "Please enter a valid phone number (at least 10 digits).";
  }

  return Object.keys(errors.value).length === 0;
};

// Create the function to remove an image
const removeImage = (id) => {
  const index = combinedImagePreviews.value.findIndex((p) => p.id === id);
  if (index === -1) return;

  // Remove the image from the preview array
  const [removedImage] = combinedImagePreviews.value.splice(index, 1);

  // If the removed image was an existing one, track its URL for deletion on the backend
  if (removedImage.type === "existing") {
    deletedImages.value.push(removedImage.src);
  }

  // If it was a new image, revoke its object URL to prevent memory leaks
  if (removedImage.type === "new") {
    URL.revokeObjectURL(removedImage.src);
  }
};

const handleFileUpload = (event) => {
  const selectedFiles = event.target.files;
  if (!selectedFiles) return;

  const fileArray = Array.from(selectedFiles);

  // Combine existing images with new files for validation
  const totalImages = combinedImagePreviews.value.length + fileArray.length;

  if (totalImages > 8) {
    // Use SweetAlert for the warning
    Swal.fire({
      title: "Upload Limit Exceeded",
      text: "Please select a maximum of 8 images.",
      icon: "warning",
      confirmButtonText: "OK",
    });
    // Clear the file input and previews
    event.target.value = null;

    return;
  }

  // 7. Create structured objects for new files
  const newPreviews = fileArray.map((file, index) => ({
    id: `new-${index}-${Date.now()}`,
    src: URL.createObjectURL(file),
    type: "new",
    file: file,
  }));

  combinedImagePreviews.value.push(...newPreviews);

  //files.value = [...(files.value || []), ...fileArray];

  // 2. Generate new preview URLs from the selected files
  //  const newPreviews = fileArray.map((file) => URL.createObjectURL(file));
  //imagePreviews.value.push(...newPreviews);

  // Clear any previous file-related errors
  if (errors.value.files) {
    delete errors.value.files;
  }
};

// Send message method
const sendMessage = async () => {
  // First, run validation. If it fails, stop the function.
  if (!validate()) {
    const firstErrorField = document.querySelector(".error-message");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return;
  }

  try {
    // loading.value = true;

    ForRent.value = status.value === "For Rent";

    // 1. Initialize the final images array with the existing image URLs.
    // These are the URLs from the database, not Base64.


     // --- NEW SORTING LOGIC ---
    // Create a mutable copy of the previews to sort them.
    const sortedPreviews = [...combinedImagePreviews.value];
// Helper function to extract the number from a filename (e.g., "img_01.jpg" -> 1)
    const extractNumber = (filename) => {
      if (!filename) return Infinity; // Place items without a name at the end
      const match = filename.match(/(\d+)\.\w+$/); // Matches number before the extension
      return match ? parseInt(match[1], 10) : Infinity;
    };
// Helper function to get the filename from a preview object
    const getFilename = (preview) => {
      if (preview.type === 'existing') {
        try {
          // Decode the URL and get the last part of the path
          const path = decodeURIComponent(new URL(preview.src).pathname);
          return path.substring(path.lastIndexOf('/') + 1);
        } catch (e) {
          return ''; // Return empty string for invalid URLs
        }
      } else { // type === 'new'
        return preview.file ? preview.file.name : '';
      }
    };

    // Sort the array based on the extracted number
    sortedPreviews.sort((a, b) => {
      const numberA = extractNumber(getFilename(a));
      const numberB = extractNumber(getFilename(b));
      return numberA - numberB;
    });


    const finalImages = [];
    const imagePromises = sortedPreviews.map((preview) => {
      if (preview.type === "existing") {
        return preview.src; // It's already a URL, just return it
      } else {
        return toBase64(preview.file); // It's a new file, convert to Base64
      }
    });

    const resolvedImages = await Promise.all(imagePromises);
    finalImages.push(...resolvedImages);

    const allFeaturesList = [
      "Air Condition",
      "Electricity Bill Included",
      "Internet",
      "Microwave",
      "Smoking allowed",
      "Pets Allowed",
      "Elevator",
      "Parking",
      "Garage",
      "Lawn maintenance",
      "Tenant Insurance needed",
      "Water Bill Included",
      "Washer and Dryer",
      "Furnished",
      "Security Check",
    ];

    const featuresPayload = {};
    allFeaturesList.forEach((featureName) => {
      featuresPayload[featureName] = features.value.includes(featureName)
        ? "Yes"
        : "No";
    });

    const payload = {
      propertyTitle: propertyTitle.value || "",
      Type: String(propertyType.value || ""),
      PropertyAmount: price.value || "",
      Sqft: area.value || "",
      Bedrooms: String(bedrooms.value || ""),
      Washrooms: String(bathrooms.value || ""),
      City: city.value || "",
      Province: state.value || "",
      PostalCode: zipCode.value || "",
      description: description.value || "",
      features: featuresPayload,
      name: name.value || "",
      email: email.value || "",
      phone: phone.value || "",
      gdprAgreement: gdprAgreement.value,
      AddressLine1: streetNumber.value + " " + route.value || "",
      availableDate: availableDate.value || null,
      Verified: false,
      ForRent: ForRent.value,
      PlaceId: placeId.value,
      latitude: latitude.value,
      longitude: longitude.value,
      PropertyClosed: false,
      videoUrl: videoUrl.value || "",
      images: finalImages,
      PropertyArchived: false,
      streetName: route.value || "",
      streetNumber: streetNumber.value || "",
      autoAddress: address.value || "",
    };

    if (isEditMode.value && propertyId.value) {
      payload.id = propertyId.value;
      // 9. Add the list of deleted image URLs to the payload
      if (deletedImages.value.length > 0) {
        payload.deletedImages = deletedImages.value;
      }
    }

    isSubmitting.value = true;
    let response = null;

    // 1. Get the user from the Vuex store
    const user = store.state.auth.user;
    let token = null;

    // 2. If the user exists, get their ID token
    if (user) {
      try {
        token = await user.getIdToken();
      } catch (tokenError) {
        console.error("Error getting auth token:", tokenError);
        Swal.fire({
          title: "Authentication Error",
          text: "Could not get authentication token. Please try logging in again.",
          icon: "error",
        });
        isSubmitting.value = false;
        return;
      }
    }

    if (isEditMode.value)
      response = await fetch(process.env.VUE_APP_updateProperty, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(payload),
      });
    else
      response = await fetch(process.env.VUE_APP_submitProperty, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Server Error: ${response.status} ${response.statusText} - ${errorText}`
      );
    }

    const result = await response.json();
    console.log("Property action successfully:", result);

    // Define dynamic success messages based on the mode
    const successTitle = isEditMode.value ? "Updated!" : "Submitted!";
    const successText = isEditMode.value
      ? "Your property has been updated successfully."
      : "Your property has been submitted for review. Thank you!";

    // 6. Replace alert with SweetAlert for success
    Swal.fire({
      title: successTitle,
      text: successText,
      icon: "success",
      confirmButtonText: "Back to Home",
      confirmButtonColor: "#0d6efd",
    }).then((result) => {
      // 7. Navigate to home page after user clicks "OK"
      if (result.isConfirmed) {
        router.push("/");
      }
    });
  } catch (error) {
    console.error("Error submitting property:", error);
    Swal.fire({
      title: "Error!",
      text: `Failed to action property. ${error.message}`,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#dc3545",
    });
  } finally {
    // loading.value = false;
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
.error-message {
  color: #dc3545; /* Bootstrap's danger color */
  font-size: 0.875em;
  margin-top: 0.25rem;
}

.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Dimmed background */
  z-index: 1050; /* Ensure it appears above other elements */
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-container {
  text-align: center;
}
/* 5. Add styles for the image preview container */
.image-preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  padding: 10px;
  border: 1px dashed #ccc;
  border-radius: 8px;
}

.image-preview-item {
  position: relative;
  width: 100px;
  height: 100px;
  cursor: grab;
}

.image-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.remove-image-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #dc3545; /* Bootstrap danger color */
  color: white;
  border: 1px solid white;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  font-weight: bold;
  z-index: 10;

  /* Add flexbox for perfect centering */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Adjust font-size and padding for a better look */
  font-size: 16px;
  padding: 0;
  line-height: 1; /* Prevents line-height from adding extra space */
}
</style>
